module.exports = __webpack_public_path__ + "img/jixiao.1be8cd6e.png";